import { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";

// Middleware imports (keep eager)

// Constants (keep eager)
import {
  CROSSCUT_FACTORY_ISSUE_ORDER,
  DRESSING_FACTORY_ISSUE_ORDER,
  FACTORY_ACCO,
  FACTORY_BUNITO,
  FACTORY_BUNITO_ADD,
  FACTORY_CANVAS,
  FACTORY_CANVAS_ADD,
  FACTORY_CNC,
  FACTORY_CNC_ADD,
  FACTORY_COLOUR,
  FACTORY_COLOUR_ADD,
  FACTORY_CREATE_PLYWOOD_PRODUCTION,
  FACTORY_DRESSING,
  FACTORY_DRESSING_ADD,
  FACTORY_DRESSING_EDIT,
  FACTORY_EDIT_PLYWOOD_PRODUCTION,
  FACTORY_GROUPING,
  FACTORY_GROUPING_ADD,
  FACTORY_GROUPING_EDIT,
  FACTORY_PLYWOOD_PRODUCTION,
  FACTORY_POLISHING,
  FACTORY_POLISHING_ADD,
  FACTORY_PRESSING,
  FACTORY_PRESSING_ADD,
  FACTORY_PRESSING_EDIT,
  FACTORY_RE_DRESSING_ADD,
  FACTORY_RE_SIZING_PLYWOOD,
  FACTORY_RE_SIZING_PLYWOOD_ADD,
  FACTORY_RE_SIZING_PLYWOOD_EDIT,
  FACTORY_RE_SLICING_ADD,
  FACTORY_REGROUPING_ADD,
  FACTORY_SLICING,
  FACTORY_SLICING_ADD,
  FACTORY_SLICING_EDIT,
  FACTORY_SMOKING_DYING,
  FACTORY_SMOKING_DYING_ADD,
  FACTORY_SMOKING_DYING_EDIT,
  FACTORY_TAPPING,
  FACTORY_TAPPING_ADD,
  FACTORY_TAPPING_EDIT,
  FLITCHING_FACTORY_ISSUE_ORDER,
  GROUPING_FACTORY_ISSUE_ORDER,
  PEELING_FACTORY,
  PEELING_FACTORY_ADD,
  PEELING_FACTORY_EDIT,
  PEELING_FLITCH_FACTORY_ADD,
  PEELING_FLITCH_FACTORY_EDIT,
} from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy-loaded components
const FactoryCrosscut = lazy(() => import("app/pages/Factory/CrossCut"));
const CreateCrossCut = lazy(() => import("app/pages/Factory/CrossCut/IssueForCrossCut/CreateCrossCut"));
const EditCrossCutDone = lazy(() => import("app/pages/Factory/CrossCut/CrossCutDone/Edit"));
const CrosscuttingApprovalDetails = lazy(() => import("app/pages/Factory/CrossCut/CrossCutDone/Approval/ViewDetails"));
const CrossCutIssueOrder = lazy(() => import("app/pages/Factory/CrossCut/CrossCutDone/CrossCutIssueOrder"));

const CreatePressing = lazy(() => import("app/pages/Factory/PressingFactory/CreatePressing"));
const FactoryPressing = lazy(() => import("app/pages/Factory/PressingFactory"));

const FactoryFlitching = lazy(() => import("app/pages/Factory/Flitching"));
const CreateFlitching = lazy(() => import("app/pages/Factory/Flitching/CreateFlitching"));
const EditFlitchingDone = lazy(() => import("app/pages/Factory/Flitching/FlitchingDone/Edit"));
const FlitchingApprovalDetails = lazy(() => import("app/pages/Factory/Flitching/FlitchingDone/Approval/ViewDetails"));
const FlitchingIssueOrder = lazy(() => import("app/pages/Factory/Flitching/FlitchingDone/FlitchingIssueOrder"));

const FactoryPeeling = lazy(() => import("app/pages/Factory/Peeling"));
const CreatePeeling = lazy(() => import("app/pages/Factory/Peeling/CreatePeeling"));
const EditPeelingDone = lazy(() => import("app/pages/Factory/Peeling/PeelingDone/Edit"));
const CreateFlitch = lazy(() => import("app/pages/Factory/Peeling/CreateFlitch"));
const EditFlitchDone = lazy(() => import("app/pages/Factory/Peeling/reFlitchingDone/EditFlitchDone"));

const FactorySlicing = lazy(() => import("app/pages/Factory/Slicing"));
const CreateSlicing = lazy(() => import("app/pages/Factory/Slicing/CreateSlicing"));
const CreateReSlicing = lazy(() => import("app/pages/Factory/Slicing/CreateReSlicing"));
const EditSlicing = lazy(() => import("app/pages/Factory/Slicing/EditSlicing"));

const FactoryGrouping = lazy(() => import("app/pages/Factory/Grouping"));
const CreateGrouping = lazy(() => import("app/pages/Factory/Grouping/CreateGrouping"));
const EditGrouping = lazy(() => import("app/pages/Factory/Grouping/GroupingDone/EditGrouping"));
const ReCreateGrouping = lazy(() => import("app/pages/Factory/Grouping/ReCreateGrouping"));
const IssueOrderGrouping = lazy(() => import("app/pages/Factory/Grouping/IssueOrder"));

const FactoryDressing = lazy(() => import("app/pages/Factory/Dressing"));
const CreateDressing = lazy(() => import("app/pages/Factory/Dressing/CreateDressing"));
const EditDressing = lazy(() => import("app/pages/Factory/Dressing/EditDressing"));
const DressingIssueOrder = lazy(() => import("app/pages/Factory/Dressing/DressingDone/DressingIssueOrder"));

const FactorySmokingDying = lazy(() => import("app/pages/Factory/SmokingDying"));
const CreateSmokingDying = lazy(() => import("app/pages/Factory/SmokingDying/CreateSmokingDying"));

const FactoryTapping = lazy(() => import("app/pages/Factory/TappingFactory"));
const CreateTappingFactory = lazy(() => import("app/pages/Factory/TappingFactory/CreateTapping"));
const EditTappingFactory = lazy(() => import("app/pages/Factory/TappingFactory/TappingDone/EditTapping"));

const FactoryCnc = lazy(() => import("app/pages/Factory/CncFactory"));
const CreateCnc = lazy(() => import("app/pages/Factory/CncFactory/CreateCnc"));

const FactoryColour = lazy(() => import("app/pages/Factory/ColourFactory"));
const CreateColour = lazy(() => import("app/pages/Factory/ColourFactory/CreateColour"));

const FactoryBunito = lazy(() => import("app/pages/Factory/BunitoFactory"));
const CreateBunito = lazy(() => import("app/pages/Factory/BunitoFactory/CreateBunito"));

const FactoryCanvas = lazy(() => import("app/pages/Factory/CanvasFactory"));
const CreateCanvas = lazy(() => import("app/pages/Factory/CanvasFactory/CreateCanvas"));

const FactoryPolishing = lazy(() => import("app/pages/Factory/PolishingFactory"));
const CreatePolishing = lazy(() => import("app/pages/Factory/PolishingFactory/CreatePolishing"));

const FactoryAcco = lazy(() => import("app/pages/Factory/AccoFactory"));

const FactoryPlywoodProduction = lazy(() => import("app/pages/Factory/PlywoodProductionFactory"));
const CreatePlywoodProduction = lazy(() => import("app/pages/Factory/PlywoodProductionFactory/CreatePlywoodProduction"));
const EditPlywoodProduction = lazy(() => import("app/pages/Factory/PlywoodProductionFactory/EditPlywoodProduction"));

const FactoryReSizingPlywood = lazy(() => import("app/pages/Factory/ReSizingPlywoodFactory"));
const CreateReSizingPlywood = lazy(() => import("app/pages/Factory/ReSizingPlywoodFactory/CreateReSizingPlywood"));
const EditReSizingPlywood = lazy(() => import("app/pages/Factory/ReSizingPlywoodFactory/ReSizingPlywoodDone/EditReSizingPlywood"));

export const factoryRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "crosscut_factory", "view"],
      },
    ],
    routes: [
      {
        path: "factory/crosscut",
        element: LoadablePage(FactoryCrosscut),
      },
      {
        path: "factory/add-crosscut",
        element: LoadablePage(CreateCrossCut),
      },
      {
        path: "factory/edit-crosscut",
        element: LoadablePage(EditCrossCutDone),
      },
      {
        path: "factory/crosscut-approval/view-details/:id/:issued_for_cutting_id",
        element: LoadablePage(CrosscuttingApprovalDetails),
      },
      {
        path: CROSSCUT_FACTORY_ISSUE_ORDER,
        element: LoadablePage(CrossCutIssueOrder),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "flitching_factory", "view"],
      },
    ],
    routes: [
      {
        path: "factory/flitching",
        element: LoadablePage(FactoryFlitching),
      },
      {
        path: "factory/add-flitching",
        element: LoadablePage(CreateFlitching),
      },
      {
        path: "factory/edit-flitching",
        element: LoadablePage(EditFlitchingDone),
      },
      {
        path: "factory/flitching-approval/view-details/:id/:issue_for_flitching_id",
        element: LoadablePage(FlitchingApprovalDetails),
      },
      {
        path: FLITCHING_FACTORY_ISSUE_ORDER,
        element: LoadablePage(FlitchingIssueOrder),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "peeling_factory", "view"],
      },
    ],
    routes: [
      {
        path: PEELING_FACTORY,
        element: LoadablePage(FactoryPeeling),
      },
      {
        path: PEELING_FACTORY_ADD,
        element: LoadablePage(CreatePeeling),
      },
      {
        path: PEELING_FACTORY_EDIT,
        element: LoadablePage(EditPeelingDone),
      },
      {
        path: PEELING_FLITCH_FACTORY_ADD,
        element: LoadablePage(CreateFlitch),
      },
      {
        path: PEELING_FLITCH_FACTORY_EDIT,
        element: LoadablePage(EditFlitchDone),
      },
      {
        path: "factory/flitching-approval/view-details/:id/:issue_for_flitching_id",
        element: LoadablePage(FlitchingApprovalDetails),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "smoking_dying_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_SMOKING_DYING,
        element: LoadablePage(FactorySmokingDying),
      },
      {
        path: FACTORY_SMOKING_DYING_ADD,
        element: LoadablePage(CreateSmokingDying),
      },
      {
        path: FACTORY_SMOKING_DYING_EDIT,
        element: LoadablePage(CreateSmokingDying),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "slicing_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_SLICING,
        element: LoadablePage(FactorySlicing),
      },
      {
        path: FACTORY_SLICING_ADD,
        element: LoadablePage(CreateSlicing),
      },
      {
        path: FACTORY_RE_SLICING_ADD,
        element: LoadablePage(CreateReSlicing),
      },
      {
        path: FACTORY_SLICING_EDIT,
        element: LoadablePage(EditSlicing),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "grouping_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_GROUPING,
        element: LoadablePage(FactoryGrouping),
      },
      {
        path: FACTORY_GROUPING_ADD,
        element: LoadablePage(CreateGrouping),
      },
      {
        path: FACTORY_GROUPING_EDIT,
        element: LoadablePage(EditGrouping),
      },
      {
        path: FACTORY_REGROUPING_ADD,
        element: LoadablePage(ReCreateGrouping),
      },
      {
        path: FACTORY_RE_SLICING_ADD,
        element: LoadablePage(CreateReSlicing),
      },
      {
        path: FACTORY_SLICING_EDIT,
        element: LoadablePage(EditSlicing),
      },
      {
        path: GROUPING_FACTORY_ISSUE_ORDER,
        element: LoadablePage(IssueOrderGrouping),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "dressing_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_DRESSING,
        element: LoadablePage(FactoryDressing),
      },
      {
        path: FACTORY_DRESSING_ADD,
        element: LoadablePage(CreateDressing),
      },
      {
        path: FACTORY_RE_DRESSING_ADD,
        element: LoadablePage(CreateReSlicing),
      },
      {
        path: FACTORY_DRESSING_EDIT,
        element: LoadablePage(EditDressing),
      },
      {
        path: DRESSING_FACTORY_ISSUE_ORDER,
        element: LoadablePage(DressingIssueOrder),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "tapping_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_TAPPING,
        element: LoadablePage(FactoryTapping),
      },
      {
        path: FACTORY_TAPPING_ADD,
        element: LoadablePage(CreateTappingFactory),
      },
      {
        path: FACTORY_TAPPING_EDIT,
        element: LoadablePage(EditTappingFactory),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "pressing_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_PRESSING,
        element: LoadablePage(FactoryPressing),
      },
      {
        path: FACTORY_PRESSING_ADD,
        element: LoadablePage(CreatePressing),
      },
      {
        path: FACTORY_PRESSING_EDIT,
        element: LoadablePage(CreatePressing),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "cnc_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_CNC,
        element: LoadablePage(FactoryCnc),
      },
      {
        path: FACTORY_CNC_ADD,
        element: LoadablePage(CreateCnc),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "colour_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_COLOUR,
        element: LoadablePage(FactoryColour),
      },
      {
        path: FACTORY_COLOUR_ADD,
        element: LoadablePage(CreateColour),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "bunito_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_BUNITO,
        element: LoadablePage(FactoryBunito),
      },
      {
        path: FACTORY_BUNITO_ADD,
        element: LoadablePage(CreateBunito),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "canvas_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_CANVAS,
        element: LoadablePage(FactoryCanvas),
      },
      {
        path: FACTORY_CANVAS_ADD,
        element: LoadablePage(CreateCanvas),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "polishing_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_POLISHING,
        element: LoadablePage(FactoryPolishing),
      },
      {
        path: FACTORY_POLISHING_ADD,
        element: LoadablePage(CreatePolishing),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "acco_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_ACCO,
        element: LoadablePage(FactoryAcco),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "plywood_production_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_PLYWOOD_PRODUCTION,
        element: LoadablePage(FactoryPlywoodProduction),
      },
      {
        path: FACTORY_CREATE_PLYWOOD_PRODUCTION,
        element: LoadablePage(CreatePlywoodProduction),
      },
      {
        path: FACTORY_EDIT_PLYWOOD_PRODUCTION,
        element: LoadablePage(EditPlywoodProduction),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "re_sizing_plywood_factory", "view"],
      },
    ],
    routes: [
      {
        path: FACTORY_RE_SIZING_PLYWOOD,
        element: LoadablePage(FactoryReSizingPlywood),
      },
      {
        path: FACTORY_RE_SIZING_PLYWOOD_ADD,
        element: LoadablePage(CreateReSizingPlywood),
      },
      {
        path: FACTORY_RE_SIZING_PLYWOOD_EDIT,
        element: LoadablePage(EditReSizingPlywood),
      },
    ],
  },
];
